module.exports = __webpack_public_path__ + "static/media/3DPPA24.d91205d2.jpg";